<!-- Toolbar Overrides Title-->
@if ((orderContext$ | async).order; as order) {
  <ng-template elderToolbarColumn="left">
    <elder-header
      [header]="('orders.prod.order' | translate) + ' ' + order.id"
      [subheader]="order.projectDescription + ' / ' + order.description"
    >
    </elder-header>
  </ng-template>
}

<!-- Toolbar Overrides Actions -->
@if ((orderContext$ | async).order; as order) {
  <ng-template elderToolbarColumn="right.actions">
    <div class="layout-row place-start-center">
      <app-entity-link
        [entityType]="'order'"
        [ignoreServices]="'prc'"
        [entityId]="order.id"
        [company]="order.company"
      >
      </app-entity-link>
    </div>
  </ng-template>
}

<div class="layout-col full">
  <mat-tab-group
    elderTabGroupRouting="prodOrderDetailTab"
    class="flex"
    animationDuration="0ms"
    [(selectedIndex)]="tabIndex"
  >
    <!-- Detail Tab -->
    <mat-tab [label]="'orders.prod.order' | translate" elderTab="detail">
      @if (orderContext$ | async; as orderContext) {
        @if (orderContext?.order) {
          <app-prod-order-detail class="flex" [order]="orderContext?.order">
          </app-prod-order-detail>
        } @else {
          <!-- Fallback when order is not available -->
          @if (orderContext.error) {
            <elder-single-pane-wrapper class="flex">
              <elder-pane-header>
                <elder-pane-title>
                  <span>{{ 'orders.prod.order' | translate }} {{ orderContext.orderNumber }}</span>
                </elder-pane-title>
              </elder-pane-header>
              <elder-pane-content>
                <div class="layout-row place-start-center gap-sm">
                  <mat-icon color="warn">warning</mat-icon>
                  <span>{{ orderContext.error }}</span>
                </div>
              </elder-pane-content>
            </elder-single-pane-wrapper>
          }
        }
      }
    </mat-tab>

    <!-- Work orders Tab -->
    @for (workOrder of workOrders$ | async; track workOrder; let i = $index) {
      <mat-tab elderTab="{{ workOrder.id }}">
        <ng-template matTabLabel>
          <div class="layout-col">
            <span>{{ 'orders.work.order' | translate }} #{{ i + 1 }}</span>
            <span class="mat-caption">
              ({{ workOrder.manufactureFacility }}/{{ workOrder.collectingFacility }})
              {{ workOrder.id }}
            </span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <app-work-order-full
            class="flex"
            [workOrder]="workOrder"
            (deleted)="onWorkOrderDeleted()"
            (reloadWorkOrdersForProdOrder)="reloadWorkOrdersForProdOrder($event)"
          >
          </app-work-order-full>
        </ng-template>
      </mat-tab>
    }

    <!-- Dispatch Tab -->
    <mat-tab [label]="'transit.title' | translate" elderTab="dispatch">
      <ng-template matTabContent>
        <app-prod-order-dispatch
          class="flex"
          [prodOrder]="order"
          (assignmentChange)="onAssignmentChange($event)"
        >
        </app-prod-order-dispatch>
      </ng-template>
    </mat-tab>

    <!-- Attachment Tab -->
    <mat-tab [label]="'context.attachments' | translate" disabled elderTab="attachments">
      <ng-template matTabContent> </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
